/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SecureTransferInformationRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {SecureTransferInformationResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const secureTransferInformation = (request:SecureTransferInformationRequest, options?: CashRequestOptions) => post<SecureTransferInformationRequest, SecureTransferInformationResponse>("/2.0/cash/secure-transfer-information", request, {...options, rejectOnError: true })